<template>
  <ArvaModal
    name="confirmDeleteInsetOrderModal"
    title="Confirm Inset Order Deletion"
    :wide="true"
    @close-modal="handleCloseModal"
  >
    <v-card class="pa-5">
      Delete "{{ currentOrderName }} (ID: {{ currentOrderID }})"? This can not
      be undone.
      <!-- also have a input for order name-->
      <ArvaModalSaveFooter
        confirmText="Confirm Delete"
        cancelText="Cancel"
        @on-cancel="handleCloseModal"
        @on-confirm="handleSubmit"
      />
    </v-card>
  </ArvaModal>
</template>

<script>
import ArvaModal from "@/components/modals/ArvaModal"
import ArvaModalSaveFooter from "@/components/modals/ArvaModalSaveFooter"
import CarbonReadyAPI from "@/api/CarbonReadyAPI"

export default {
  name: "ConfirmDeleteInsetOrderModal",
  props: ["currentOrderName", "currentOrderID"],
  components: { ArvaModal, ArvaModalSaveFooter },

  data() {
    return {}
  },

  methods: {
    handleCloseModal() {
      this.$emit("close-modal")
    },
    handleSubmit() {
      let payload = { id: this.currentOrderID }
      CarbonReadyAPI.deleteInsetOrder(payload).then(response => {
        this.$emit("confirm-delete-modal")
      })
    },
  },
}
</script>

<style scoped>
.pw-error {
  color: red;
  font-weight: 500;
}
</style>
